import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=70888b4e"
import script from "./OfferEdit.vue?vue&type=script&lang=ts"
export * from "./OfferEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports